var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectPermissions, makeSelectSingleTargetPermissions, selectPermissionsLoadingState, } from '../../store/permissions/selectors';
import * as permissionsActions from '../../store/permissions/actions';
import { LoadingWrapper } from './styles';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export var PermissionsWrapper = function (_a) {
    var children = _a.children, target = _a.target, _b = _a.multiTargets, multiTargets = _b === void 0 ? [] : _b, action = _a.action, hideOnDisable = _a.hideOnDisable, CustomWrapper = _a.CustomWrapper, AlternateChildren = _a.AlternateChildren, insideTable = _a.insideTable;
    var permissionTargetSelector = useMemo(function () { return makeSelectSingleTargetPermissions(target); }, [target]);
    var allPermissionSelector = useMemo(function () { return makeSelectPermissions(); }, []);
    var permission = useSelector(permissionTargetSelector);
    var allPermissions = useSelector(allPermissionSelector);
    var initialRef = useRef(true);
    var loading = useSelector(selectPermissionsLoadingState);
    var dispatch = useDispatch();
    useEffect(function () {
        if (!!target) {
            dispatch(permissionsActions.getPermissionsByTargets([target]));
        }
    }, [target, action, dispatch]);
    useEffect(function () {
        if (!initialRef.current && multiTargets.length > 0) {
            return;
        }
        initialRef.current = false;
        if (multiTargets.length > 0) {
            dispatch(permissionsActions.getPermissionsByTargets(multiTargets));
        }
    }, [multiTargets, multiTargets === null || multiTargets === void 0 ? void 0 : multiTargets.length, action, dispatch, target]);
    var valid = multiTargets.length
        ? multiTargets.some(function (mt) { var _a; return (_a = allPermissions[mt]) === null || _a === void 0 ? void 0 : _a.includes(action); })
        : permission === null || permission === void 0 ? void 0 : permission.includes(action);
    var disabled = !(target || (multiTargets === null || multiTargets === void 0 ? void 0 : multiTargets.length)) || !action || !valid;
    var SelectedWrapper = !CustomWrapper ? LoadingWrapper : CustomWrapper;
    if (hideOnDisable && disabled) {
        return null;
    }
    else if (AlternateChildren && disabled) {
        return loading ? (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true })) : (_jsx(AlternateChildren, {}));
    }
    return (_jsx(SelectedWrapper, __assign({ disabled: disabled, loading: disabled && loading, insideTable: insideTable }, { children: children })));
};
